<script setup lang="ts">
import BaseLayout from "@/layouts/BaseLayout.vue";
import {router, useForm} from "@inertiajs/vue3";
import {route} from "ziggy-js";
import VFieldLabel from "@/components/forms/VFieldLabel.vue";

defineOptions({layout: BaseLayout})

interface Props {
    title: string
}

const props = defineProps<Props>();

const form = useForm({
    name: '',
    short_name: '',
    email: '',
    description: '',
    members: '',
    url: '',
})

const submit = () => {
    form.post(route('teams.store'), {
        preserveState: true,
    })
}

const goBack = () => {
    router.get(route('teams.index'))
}
</script>

<template>
    <v-container>
        <v-row class="align-center justify-space-between px-3">
            <h1 class="text-h4 font-weight-bold">
                {{ props.title }}
            </h1>
        </v-row>
        <v-form
            @submit.prevent="submit"
        >
            <v-row class="mt-5">
                <v-col
                    cols="12"
                    class="py-0"
                >
                    <v-field-label>
                        Resource name
                    </v-field-label>
                    <v-text-field
                        v-model="form.name"
                        type="text"
                        name="name"
                        class="mb-3"
                        placeholder="My Resource"
                        width="350"
                        density="compact"
                        :hide-details="!form.errors.name"
                        :error-messages="form.errors.name"
                        autofocus
                    />
                    <v-field-label>
                        Resource short name
                    </v-field-label>
                    <v-text-field
                        v-model="form.short_name"
                        type="text"
                        name="short_name"
                        class="mb-1"
                        placeholder="my-resource"
                        width="300"
                        density="compact"
                        :hide-details="!form.errors.short_name"
                        :error-messages="form.errors.short_name"
                        @input="form.short_name = form.short_name.toLowerCase().replace(/[^a-z0-9_-]/g, '')"
                    />
                    <div class="text-body-2 text-medium-emphasis mb-3">
                        Must be unique, only letters, numbers, dashes, and underscores are allowed.
                    </div>
                    <v-field-label>
                        Resource email
                    </v-field-label>
                    <v-text-field
                        v-model="form.email"
                        type="email"
                        name="email"
                        class="mb-3"
                        width="350"
                        density="compact"
                        placeholder="my-resource@example.com"
                        :hide-details="!form.errors.email"
                        :error-messages="form.errors.email"
                    />
                    <v-field-label>
                        Resource URL (optional)
                    </v-field-label>
                    <v-text-field
                        v-model="form.url"
                        type="url"
                        name="url"
                        class="mb-3"
                        width="350"
                        density="compact"
                        placeholder="https://my-resource.example.com"
                        :hide-details="!form.errors.url"
                        :error-messages="form.errors.url"
                    />
                    <v-field-label>
                        Resource description (optional)
                    </v-field-label>
                    <v-textarea
                        v-model="form.description"
                        name="description"
                        class="mb-3"
                        width="500"
                        rows="3"
                        density="compact"
                        placeholder="A brief description of the resource"
                        :hide-details="!form.errors.description"
                        :error-messages="form.errors.description"
                    />
                    <v-field-label>
                        Resource institutions and members (optional)
                    </v-field-label>
                    <v-textarea
                        v-model="form.members"
                        name="members"
                        class="mb-3"
                        width="500"
                        rows="3"
                        density="compact"
                        placeholder="A comma-separated list of institutions and members that will be part of this resource."
                        :hide-details="!form.errors.members"
                        :error-messages="form.errors.members"
                    />
                </v-col>
            </v-row>
            <v-row>
                <v-col
                    cols="12"
                    class="px-0"
                >
                    <v-btn
                        color="primary"
                        type="submit"
                    >
                        Create resource
                    </v-btn>
                    <v-btn
                        color="black"
                        variant="text"
                        border="sm"
                        class="ml-2"
                        @click="goBack"
                    >
                        <span class="font-weight-regular">
                            Cancel
                        </span>
                    </v-btn>
                </v-col>
            </v-row>
        </v-form>
    </v-container>
</template>

<style scoped>
</style>
